/**
 * ChainForge Frontend — Runtime Configuration
 *
 * Notes:
 * - CRA requires env vars prefixed with REACT_APP_*
 * - Local dev defaults to http://localhost:4000
 * - In production, you should set REACT_APP_API_BASE_URL.
 */

const isBrowser = typeof window !== "undefined";

const isLocalhost =
  isBrowser &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

/**
 * Returns a clean base URL:
 * - trims whitespace
 * - removes trailing slash (so `${API_BASE_URL}/path` is correct)
 */
function normalizeBaseUrl(value) {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  return trimmed.replace(/\/+$/, "");
}

/**
 * CRA: REACT_APP_API_BASE_URL
 * (Optional fallback if you ever move away from CRA builds)
 */
const envBaseUrl =
  normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL) ||
  normalizeBaseUrl(process.env.API_BASE_URL);

/**
 * Default local dev backend:
 * - if frontend is on localhost, assume backend is localhost:4000
 */
const localDefault = "http://localhost:4000";

export const API_BASE_URL = envBaseUrl || (isLocalhost ? localDefault : "");

/**
 * Helpful warning when deploying without configuring the backend URL.
 * We don't throw to avoid breaking the app unexpectedly, but we do warn loudly.
 */
if (!API_BASE_URL && typeof console !== "undefined") {
  console.warn(
    "[ChainForge] API_BASE_URL is empty. Set REACT_APP_API_BASE_URL in production (e.g. Vercel env vars)."
  );
}